<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { useConfirm } from 'primevue/useconfirm'
import { useToast } from 'primevue/usetoast'

usePostHog()

useDark()
const toast = useToast()
const confirm = useConfirm()
provide('confirm', confirm)
provide('toast', toast)

const notificationStore = useNotificationStore()

watch(notificationStore.notifications, (newNotifications) => {
  for (let index = newNotifications.length - 1; index >= 0; index -= 1) {
    const notification = newNotifications[index]
    toast.add({
      severity: notification.type,
      summary: notification.message,
      group: notification.group,
      life: notification.sticky ? undefined : notification.life || 3000
    })
    notificationStore.removeNotification(index)
  }
})
</script>

<template>
  <div>
    <Toast />
    <Toast group="config-reload">
      <template #message="{ message }">
        <span class="block text-sm leading-5">{{ message.summary }}</span>
      </template>
    </Toast>
    <ConfirmDialog />
    <MaintenanceOverlay />
    <NewVersionBanner />
    <DefaultLayout />
    <VueQueryDevtools v-if="false" />
  </div>
</template>
